export const TIMEZONE = 'America/Port_of_Spain';
